const getDayOfWeek = (date) => {
    const options = { weekday: "long" };
    const day = date.toLocaleDateString("bg-BG", options);
    return day;
}

const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);

    return newDate;
}

const formatDate = (date) => {
    return date.toLocaleDateString("bg-BG", { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const formatToISO = (date) => {
    const offset = date.getTimezoneOffset() * 60000;
    const localISOTime = (new Date(date.getTime() - offset)).toISOString().slice(0, -1);

    return localISOTime;
}

const areAllArraysEmpty = (obj) => {
    return Object.values(obj).every(arr => arr.length === 0);
}

const BGN_EUR_RATE = 1.95583;
const DEFAULT_COURSE_PRICE_EUR = 20;

const toLeva = (priceEur) => priceEur * BGN_EUR_RATE;

const formatEur = (priceEur) => `€${Number(priceEur).toFixed(2)}`;

const formatLevaTooltip = (priceEur) => `${toLeva(priceEur).toFixed(2)} лв.`;


export { getDayOfWeek, addDays, areAllArraysEmpty, BGN_EUR_RATE, DEFAULT_COURSE_PRICE_EUR, toLeva, formatEur, formatLevaTooltip, formatDate, formatToISO };
